var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChevronNarrow = function SvgIconChevronNarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.071 9.915c.216-.597.856-.899 1.43-.675L12 12.55l8.499-3.31c.574-.224 1.215.078 1.43.675s-.076 1.262-.65 1.486l-8.889 3.461a1.07 1.07 0 0 1-.78 0L2.72 11.401c-.574-.224-.865-.89-.65-1.486",
    clipRule: "evenodd"
  })));
};
export default SvgIconChevronNarrow;